export var SDK_VERSION = '0.0.8';
export var STORAGE_KEY = 'collected_keys';
export var THREE_DAY = 3 * 24 * 3600 * 1000;
export var FALLBACK_SAMPLE_RATIO = 0.1;
